module.exports = __webpack_public_path__ + "img/the-kingmakers-daughter.510ef841.png";